import { Typography } from '@mui/material'
import { ReactNode } from 'react'
import { FieldPath, FieldValues, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

type Props<Schema extends FieldValues> = {
  path: FieldPath<Schema>
}

export const RefreshIntervalSoftValidator = <Schema extends FieldValues>({
  path,
}: Props<Schema>): ReactNode => {
  const { t } = useTranslation('features/domain', { keyPrefix: 'form.refresher.basicSettings' })
  const value = useWatch<Schema>({ name: path })

  if (value === undefined || value >= 30) {
    return undefined
  }

  return (
    <Typography
      component='span'
      sx={theme => ({ color: theme.palette.warning.main })}
      variant='caption'
    >
      {t('columns.refreshInterval.recommendedMinimum')}
    </Typography>
  )
}
